export default {
  zh: {
    title: '{type}报告',
    generate: '生成报告',
    groupOptions: {
      day: '按天分组',
      week: '按周分组',
      month: '按月分组',
      quarter: '按季度分组',
      year: '按年分组',
    },
    aggregateOptions: {
      summary: '和',
      average: '平均值',
    },
    summary: {
      sum: '和: {val}',
      avg: '平均值: {val}',
      count: '({val}条记录)',
    },
    total: '总和',
  },
  en: {
    title: '{type} Report',
    generate: 'Generate Report',
    groupOptions: {
      day: 'Group by day',
      week: 'Group by week',
      month: 'Group by month',
      quarter: 'Group by quarter',
      year: 'Group by year',
    },
    aggregateOptions: {
      summary: 'Summary',
      average: 'Average',
    },
    summary: {
      sum: 'Sum: {val}',
      avg: 'Average: {val}',
      count: '(Counts: {val})',
    },
    total: 'Grand Total',
  },
};



// WEBPACK FOOTER //
// ./src/views/ReportPreview/i18n.js